import { Project } from '@/shared/types/Project';

const DEFAULT_INTERVAL_MS = 200;
// Вычисляет скорость, с которой должен меняться процент
export const getIntervalForChangingPercents = (
  videoDurationSec: Project['duration'],
  wholeProcessExecutingSecFor60SecVideo: number,
) => {
  // Без длины видео мы не можем вычислить скорость смены процентов. Поэтому возвращаем заглушку
  if (!videoDurationSec) {
    return DEFAULT_INTERVAL_MS;
  }
  const percentInSecFor60SecVideo = (1 / wholeProcessExecutingSecFor60SecVideo) * 100;
  const percentInSecForPassedVideo = percentInSecFor60SecVideo * (60 / videoDurationSec);
  const intervalInMsFor1Percent = (1 / percentInSecForPassedVideo) * 1000;
  return Math.round(intervalInMsFor1Percent);
};
